import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import {toast} from "react-toastify";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import TaxColumn from "../../shared/component/dataTable/columns/TaxColumn.json";
import DataTableWithButton from "../../shared/component/dataTable/DataTableWithButton";
import TaxService from "../../shared/service/TaxService";
import '../../shared/styles/SettingsPage.css';
import '../../shared/styles/MasterDetailSave.css';
import FormSection from '../../shared/component/form/FormSection';

const defaultTax = {
    id: '', name: '', status: 'ACTIVE', rate: null
};

export default class TaxSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tax: defaultTax,
            taxTemp: defaultTax,
            taxDetailsSaveButtonRender: true,
            taxList: []
        }
        this.taxService = new TaxService();
    }

    componentDidMount() {
        let obj1 = Object.assign({}, defaultTax);
        this.setState({
            tax: obj1,
            taxDetailsSaveButtonRender: false,
            taxTemp: Object.assign({}, obj1)
        });
        this.refresh();
    }

    refresh() {
        this.taxService.findAll().then(response => this.setState({
            taxList: response
        }));
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Tax Details</h1>
                        </div>

                        <div className="settings-page__panel master-detail-save">
                            <ModalConfirm
                                header="Warning"
                                ok="OK"
                                onOkClick={this.delete}
                                onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                show={this.state.displayShowStatusConfirmDialog}
                                message={this.state.noticeResponse}/>

                            <div className="master-detail-save__split">
                                <div className="master-detail-save__list">
                                    <FormSection title="Taxes" className="master-detail-save__list-section">
                                        {GeneralUtils.checkPrivilege("post_product/tax") &&
                                            <div className="settings-page__toolbar settings-page__toolbar--start master-detail-save__list-toolbar">
                                                <Button color="outline-primary" className="settings-page__btn--add" onClick={() => {
                                                    this.addNew();
                                                }}>
                                                    <i className="pi pi-plus" aria-hidden="true"/>
                                                    <Translate contentKey="entity.action.add">Add</Translate>
                                                </Button>
                                            </div>}

                                        {GeneralUtils.checkPrivilege("get_product/tax") &&
                                            <div className="settings-page__table-wrap master-detail-save__list-table">
                                                <DataTableWithButton
                                                    ref={(elem) => this.refDataTable = elem}
                                                    fields={TaxColumn.fields}
                                                    objectName={TaxColumn.name}
                                                    data={this.state.taxList}
                                                    rows={5}
                                                    selectionMode="single"
                                                    onDataSelect={this.onDataSelect}
                                                    loading={this.state.loading}/>
                                            </div>}
                                    </FormSection>
                                </div>

                                <div className="master-detail-save__details">
                                    <div className="master-detail-save__details-body">
                                        <FormSection title="Tax Details">
                                            <div className="settings-page__filter-row settings-page__filter-row--cols-2 settings-page__filter-row--wide settings-page__form-fields">
                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="tax-name">
                                                <Translate contentKey="tax.tradingName">Name</Translate>
                                                <span style={{color: 'red'}}> (*)</span>
                                            </Label>
                                            <AvField
                                                id="tax-name"
                                                type="text"
                                                className="form-control"
                                                name="name"
                                                disabled={!this.state.taxDetailsSaveButtonRender}
                                                validate={{
                                                    maxLength: {
                                                        value: 255,
                                                        errorMessage: "You can enter up to 255 characters in this field."
                                                    }
                                                }}
                                                value={this.state.tax.name}
                                                onChange={this.__handleChange}/>
                                        </AvGroup>
                                    </div>

                                    <div className="settings-page__filter-field">
                                        <AvGroup>
                                            <Label for="tax-rate">
                                                <Translate contentKey="tax.tradingName">Rate</Translate>
                                                <span style={{color: 'red'}}> (*)</span>
                                            </Label>
                                            <AvField
                                                id="tax-rate"
                                                type="number"
                                                className="form-control"
                                                name="rate"
                                                disabled={!this.state.taxDetailsSaveButtonRender}
                                                value={this.state.tax.rate}
                                                onChange={this.__handleChange}/>
                                        </AvGroup>
                                    </div>
                                </div>

                                <div className="settings-page__actions master-detail-save__form-actions">
                                    {GeneralUtils.checkPrivilege("post_product/tax") && this.state.taxDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.tax.id) &&
                                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                            this.setState({taxDetailsSaveButtonRender: true});
                                        }}>
                                            <Translate contentKey="entity.action.add">Edit</Translate>
                                        </Button>}

                                    {GeneralUtils.checkPrivilege("post_product/tax") && this.state.taxDetailsSaveButtonRender &&
                                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                            this.saveTax();
                                        }}>
                                            <Translate contentKey="entity.action.add">Save</Translate>
                                        </Button>}

                                    {GeneralUtils.checkPrivilege("delete_product/tax/_id") && this.state.taxDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.tax.id) &&
                                        <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                                            this.showChangeStatusConfirmDialog(true);
                                        }}>
                                            <Translate contentKey="entity.action.add">Delete</Translate>
                                        </Button>}

                                    {GeneralUtils.checkPrivilege("post_product/tax") && this.state.taxDetailsSaveButtonRender &&
                                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                                            let obj1 = this.state.taxTemp;
                                            this.setState({
                                                tax: Object.assign({}, obj1),
                                                taxDetailsSaveButtonRender: false
                                            });
                                        }}>
                                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                                        </Button>}
                                </div>
                                        </FormSection>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    delete = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.tax.id)) {
            this.taxService.delete(this.state.tax.id)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        let obj1 = Object.assign({}, defaultTax);
                        this.setState({
                            tax: obj1,
                            taxDetailsSaveButtonRender: false,
                            taxTemp: Object.assign({}, obj1)
                        });
                        this.refresh();
                    }
                });
        }

        return undefined;
    }

    showChangeStatusConfirmDialog = (value) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to delete?"
        });
    }

    onDataSelect = (data) => {
        this.taxService.findById(data.id).then(response => {
            this.setState({
                tax: response,
                taxDetailsSaveButtonRender: false,
                taxTemp: Object.assign({}, response)
            });
        });
    }

    saveTax = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.tax.name)) {
            return toast.warn("Please fill the required fields!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.tax.id)) {
                this.taxService.update(this.state.tax)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                taxDetailsSaveButtonRender: false,
                                tax: response,
                                taxTemp: Object.assign({}, response)
                            });
                            this.refresh();
                        }
                    });
            } else {
                this.taxService.create(this.state.tax)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.setState({
                                taxDetailsSaveButtonRender: false,
                                tax: response,
                                taxTemp: Object.assign({}, response)
                            });
                            this.refresh();
                        }
                    });
            }
        }
    }

    addNew() {
        let obj1 = Object.assign({}, defaultTax);
        this.setState({
            tax: obj1,
            taxDetailsSaveButtonRender: true,
            taxTemp: Object.assign({}, obj1)
        });
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let tax = this.state.tax;
        tax[e.target.name] = value;
        this.setState({tax: tax});
    }
}
